import React from 'react';
import { HiClipboardDocumentList } from 'react-icons/hi2';
import ComingSoon from './ComingSoon';

const PhysicalTestSettings: React.FC = () => {
  return (
    <ComingSoon
      title="Physical Test"
      description="Set up custom daily physical tests and benchmarks. Track your performance over time and get personalized recommendations for improvement."
      icon={HiClipboardDocumentList}
    />
  );
};

export default PhysicalTestSettings;